export const StepType = {
  Bid: 'BID',
  Offer: 'OFFER',
} as const;
export type StepType = (typeof StepType)[keyof typeof StepType];
